import {
  Avatar,
  Box,
  Button,
  Divider,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { CSSProperties, FC } from 'react';

import { UserMin } from '@apiContract';

import { sxAvatar, sxItemAvatar, sxItemButton, sxLocationBox } from '../../styles';

type ListItemProps = {
  selected: boolean;
  style: CSSProperties;
  user: UserMin | null;
  isNewBadge?: boolean;
  divider?: boolean;
  index: number;
};

const SelectedUsersItem: FC<ListItemProps> = ({ style, selected, user, index, isNewBadge, divider }) => {
  const theme = useTheme();

  if (!user) {
    return null;
  }

  return (
    <ListItem component="div" sx={{ ...style, flexDirection: 'column', alignItems: 'flex-start' }} disablePadding>
      {!!isNewBadge && <Typography variant="overline">New</Typography>}
      <ListItem sx={{ ...sxItemButton(selected, true, theme) }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flex={1} sx={{ minWidth: 0 }}>
          <ListItemAvatar sx={sxItemAvatar}>
            <Avatar sx={sxAvatar} alt={`${user.firstName} ${user.lastName}`} src={user.profileImageUrl}>
              {user?.firstName?.charAt(0)}
              {user?.lastName?.charAt(0)}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography
                title={user.displayName}
                variant="subtitle2"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                overflow="hidden"
              >
                {user.displayName}
              </Typography>
            }
            secondary={
              <Typography
                title={user?.userName}
                color="text.secondary"
                variant="body2"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                overflow="hidden"
              >
                {user?.userName}
              </Typography>
            }
          />
        </Box>
        <Box sx={sxLocationBox}>
          <Button title="Remove" size="small" color={selected ? 'error' : 'inherit'} data-userindex={index}>
            {selected ? 'Remove' : 'Re-Add'}
          </Button>
        </Box>
      </ListItem>
      {!!divider && <Divider sx={{ width: '100%', mt: 1 }} />}
    </ListItem>
  );
};

export default SelectedUsersItem;
